"use client";

import { cn, Icon, type IconProps } from "@kyan/ui";

export const GradientIcon: React.FC<IconProps> = ({ className, ...props }) => {
  return (
    <Icon
      size="sm"
      className={cn(
        "text-fill-transparent flex size-8 items-center justify-center rounded-[5px] border-[0.6px] border-white/10 bg-[linear-gradient(180deg,#FFF_0%,#EFEFEF_100%)] shadow-[0px_0px_4px_0px_rgba(81,81,81,0.15)_inset] before:bg-gradient-to-b before:from-[#777777] before:to-[#9C9C9C] before:bg-clip-text dark:bg-[linear-gradient(180deg,rgba(23,23,23,0.50)_0%,#1D1D1D_100%)] dark:shadow-[0px_0px_6.3px_0px_rgba(81,81,81,0.50)_inset] dark:before:from-white dark:before:to-[#999999]",
        className,
      )}
      {...props}
    />
  );
};
